document.addEventListener("DOMContentLoaded", function () {
  const netPrices = document.querySelectorAll("[data-net-price]");

  netPrices?.forEach((el) => {
    const { powerCompanyPrice, netPrice } = el.dataset;
    if (
      powerCompanyPrice === "SRP" &&
      document.querySelector("[product-net-price]")
    ) {
      document
        .querySelectorAll(".product-net-price")
        .forEach((node) => node.removeAttribute("hidden"));
      document
        .querySelectorAll(".product-price")
        .forEach((node) => (node.style.textDecoration = "line-through"));
      document
        .querySelectorAll("[product-net-price]")
        .forEach((node) => (node.innerText = netPrice));
    }
  });

  const totalDiscounts = document.querySelectorAll("[data-total-discount]");

  var buttons = document.querySelectorAll(
    "#section-book-now .buttons-options button"
  );

  buttons.forEach(function (button) {
    button.addEventListener("click", function (e) {
      buttons.forEach(function (btn) {
        btn.classList.remove("active");
      });
      this.classList.add("active");

      const powerCompany = this.dataset.powerCompany;
      if (powerCompany) {
        document
          .querySelectorAll(`[data-power-company-price]`)
          .forEach((el) => {
            if (el.dataset.powerCompanyPrice === powerCompany) {
              el.removeAttribute("hidden");
              if (el.dataset.netPrice) {
                document
                  .querySelectorAll("[product-net-price]")
                  .forEach((node) => (node.innerText = el.dataset.netPrice));
              }
            } else {
              el.setAttribute("hidden", "hidden");
            }
          });
          totalDiscounts.forEach(el => {
            console.log(el.dataset.totalDiscount)
            el.dataset.totalDiscount === powerCompany ? el.removeAttribute('hidden') : el.setAttribute('hidden', 'hidden')
          })
      }
    });
  });
});
